<button
  (click)="toggleOffCanvas()"
  class="navbar-toggler off-canvas-button off-canvas-button--open"
  type="button"
  aria-label="Menu openen"
>
  <span class="off-canvas-button-text" wlCSCapture>{{ openButtonTitle }} </span>
  <fa-icon
    class="off-canvas-button-icon"
    size="lg"
    [icon]="icon | scIcon"
  ></fa-icon>
</button>

<div
  [ngClass]="[
    direction | collapseDirection,
    backgroundColor ? 'bg-' + backgroundColor : '',
  ]"
  [class.show]="open"
  class="off-canvas-collapse"
>
  <!-- configure grid layout and positioning in css -->
  <div
    class="off-canvas-header-grid"
    [class.off-canvas-header-grid__subitems]="showBackButton"
  >
    <div class="off-canvas-header-grid--back">
      @if (showBackButton) {
        @if (hasIconOnlyButtons) {
          <crnt-icon-button
            (click)="back.emit()"
            wlAutomationId="back"
            variant="tertiary"
            class="off-canvas-button--back"
          >
            <crnt-visually-hidden>
              {{ 'Back' | translate }}
            </crnt-visually-hidden>
            <crnt-icon icon="angle-left"></crnt-icon>
          </crnt-icon-button>
        } @else {
          <crnt-button
            (click)="back.emit()"
            wlAutomationId="back"
            variant="tertiary"
            class="off-canvas-button--back"
          >
            {{ 'Back' | translate }}
            <crnt-icon slot="leading" icon="angle-left"></crnt-icon>
          </crnt-button>
        }
      }
    </div>

    <div class="off-canvas-header-grid__toggle">
      @if (hasIconOnlyButtons) {
        <crnt-icon-button
          (click)="toggleOffCanvas()"
          wlAutomationId="close"
          variant="tertiary"
          class="off-canvas-button--close"
          aria-label="Menu sluiten"
        >
          <crnt-visually-hidden>
            {{ 'Close' | translate }}
          </crnt-visually-hidden>
          <crnt-icon icon="xmark"></crnt-icon>
        </crnt-icon-button>
      } @else {
        <crnt-button
          (click)="toggleOffCanvas()"
          wlAutomationId="close"
          variant="tertiary"
          class="off-canvas-button--close"
        >
          {{ 'Close' | translate }}
          <crnt-icon slot="trailing" icon="xmark"></crnt-icon>
        </crnt-button>
      }
    </div>

    <div class="off-canvas-header-grid__title">
      @if (showTitleCollapsed) {
        <p class="h4 off-canvas__title" wlCSCapture>
          {{ title }}
        </p>
      }
    </div>

    <div class="off-canvas-header-grid__subtitle">
      <ng-content select="subtitle"></ng-content>
    </div>
  </div>

  <ng-content></ng-content>
</div>

<div
  (click)="toggleOffCanvas()"
  [class.show]="open"
  class="d-block d-lg-none backdrop"
></div>
